/* eslint-disable jsx-a11y/img-redundant-alt */
import { DataGrid } from '@mui/x-data-grid';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './datatable.scss';

import axios from 'axios';

function DataTable() {


    const [data, setData] = useState([]);
    const [success, setSuccess] = useState("");


    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(
                    // 'http://localhost:3005/admin/users',
                    'https://portal-sanieldanproperties-api.onrender.com/admin/users',
                    );
                // Add id property to each row using _id from the response
                const modifiedData = response.data.map((row) => ({
                    ...row,
                    id: row._id, // Use _id as the id property
                }));
                setData(modifiedData);
            } catch (error) {
                console.error('Error fetching users:', error);
            }
        };
    
        fetchData();
    }, []);

    console.log(data)

    const handleDelete = async (userId) => {
        console.log(userId)
        try {
            await axios.delete(
                // `http://localhost:3005/admin/delete-user/${userId}`
                `https://portal-sanieldanproperties-api.onrender.com/admin/delete-user/${userId}`,
            );

            // Remove the deleted product from the state
            setData(data.filter(product => product._id !== userId));
            setSuccess('Successfully! Deleted');
            setTimeout(() => {
                setSuccess('');
            }, 5000);
        } catch (error) {
            console.error('Error deleting product:', error);
        }
    };

    const columns = [
        {
            field: 'id',
            headerName: 'ID',
            width: 310,
            renderCell: (param) => (
                <div className="userr">
                    {/* <img src={param.row.image} alt="User Image" className="userr_image" /> */}
                    {param.row.id}
                </div>
            ),
        },
        {
            field: 'username',
            headerName: 'Username',
            width: 180,
        },
        { field: 'email', headerName: 'Email', width: 280 },
        {
            field: 'balance',
            headerName: '₦ Balance',
            width: 150,

        },
        { field: 'phoneNumber', headerName: 'Phone number', width: 120 },
        {
            field: 'action',
            headerName: 'Action',
            width: 170,
            renderCell: (params) => (
                <div className="actionn">
                    <Link to={params.row.id}>
                        <button type="button" className="view_btn">
                            Edit
                        </button>
                    </Link>
                    <button
                        type="button"
                        className="delete_btn"
                        onClick={() => handleDelete(params.row.id)}
                    >
                        Delete
                    </button>
                </div>
            ),
        },
    ];

    return (
        <div className="data_table">
             {success && (
        <div
          id="pop-up"
          style={{ zIndex: 9999, borderTopWidth: "6px" }}
          className="fixed border-green-600 shadow-xl bg-white mt-24 xl:mt-28 mr-4 max-w-xs top-0 right-0 py-2 px-3"
        >
          <h2 className="font-bold tracking-wider">Product Deleted</h2>
          <p className="text-sm text-left tracking-wider pt-1">{success}</p>
        </div>
      )}

            <DataGrid
                className="data_grid"
                rows={data}
                columns={columns}
                pageSize={10}
                rowsPerPageOptions={[10]}
                checkboxSelection
            />
        </div>
    );
}

export default DataTable;
